module.exports = __webpack_public_path__ + "static/media/tag.fec30f54.svg";